import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { reducers } from '@store/app.states';
import { clearState } from '@store/root-store/auth/clear-state.meta-reducer';
import { AuthEffects } from '@store/root-store/auth/auth.effects';
import { LoaderEffects } from '@store/root-store/loader/loader.effect';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { environment } from '@env/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export function provideRootStore() {
  return makeEnvironmentProviders([
    importProvidersFrom([
      StoreModule.forRoot(reducers, {
        metaReducers: [clearState],
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: false,
          strictStateSerializability: true,
          strictActionSerializability: false,
        },
      }),
      EffectsModule.forRoot([AuthEffects, LoaderEffects]),
      environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 25, trace: true }),
    ]),
  ]);

  // todo: migrate to new way once it's ready
  // return makeEnvironmentProviders([
  //   provideStore(reducers, {
  //     metaReducers: [clearState],
  //     runtimeChecks: {
  //       strictStateImmutability: true,
  //       strictActionImmutability: false,
  //       strictStateSerializability: true,
  //       strictActionSerializability: false,
  //     },
  //   }),
  //   provideEffects([AuthEffects, LoaderEffects]),
  //   provideStoreDevtools(),
  // ]);
}
